import { render } from "./SkillTableAccordion.vue?vue&type=template&id=62484b13&scoped=true"
import script from "./SkillTableAccordion.vue?vue&type=script&lang=ts"
export * from "./SkillTableAccordion.vue?vue&type=script&lang=ts"

import "./SkillTableAccordion.vue?vue&type=style&index=0&id=62484b13&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-62484b13"

export default script